module.exports = __webpack_public_path__ + "img/sleeping-bag-factory.c7f22698.webp";